import React, { useState, useCallback } from "react";
import { toast } from "react-toastify";

import { Container, Header, Grid, Button, Loader, Form, DropdownProps, Segment } from "semantic-ui-react";
import AliancaMenu from "../../components/Menu";
import Footer from "../../components/Footer";
import TableApp, { ITableAppRender } from "../../components/TableApp";
import AgentsRepository, { IAgentListModel } from "../../Repositories/AgentsRepository";
import errors from "../../Utils/ExtractErrors";
import ConferencesKitAgentRepository, { IConferencesAgent, IConferencesAgentParams } from "../../Repositories/ConferencesByAgent";
import numberFormat from "../../Utils/NumberFormat";
import CustomLoader from "../../components/CustomLoader";

const ConferencesByAgent: React.FC = () => {

    const date = new Date();
    const [list, setList] = useState<IConferencesAgent[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<IConferencesAgentParams>({ year: "", month: "", agentId: "" });    
    const [agents, setAgents] = useState<IAgentListModel[]>([]);

    const optionsMonth = [
        { key: "1", text: "JANEIRO", value: "1" },
        { key: "2", text: "FEVEREIRO", value: "2" },
        { key: "3", text: "MARÇO", value: "3" },
        { key: "4", text: "ABRIL", value: "4" },
        { key: "5", text: "MAIO", value: "5" },
        { key: "6", text: "JUNHO", value: "6" },
        { key: "7", text: "JULHO", value: "7" },
        { key: "8", text: "AGOSTO", value: "8" },
        { key: "9", text: "SETEMBRO", value: "9" },
        { key: "10", text: "OUTUBRO", value: "10" },
        { key: "11", text: "NOVEMBRO", value: "11" },
        { key: "12", text: "DEZEMBRO", value: "12" }
    ];

    const optionsYear = [
        { key: "1", text: "2020", value: "2020" },
        { key: "2", text: "2021", value: "2021" },
        { key: "3", text: "2022", value: "2022" },
        { key: "4", text: "2023", value: "2023" },
        { key: "5", text: "2024", value: "2024" },
        { key: "6", text: "2025", value: "2025" },
        { key: "7", text: "2026", value: "2026" },
    ];

    const load = async () => {

        setLoading(true);
        try {

            const response = await ConferencesKitAgentRepository.Conferences({
                year: state.year,
                month: state.month,
                agentId: state.agentId,                
            });

            setList(response);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    };    

    const LoadAgents = useCallback(async (id: string) => {
        const result = await AgentsRepository.List({
            filter: `Status == 1`
        });

        setAgents(result.list);
    }, []);

    const onDropdownChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value }));
        LoadAgents(value?.toString() || "");
    }

    const tableRender: ITableAppRender[] = [
        {
            header: "Kit",
            content: (x: IConferencesAgent) => x.numero,
            textAlign: "center",
            width: 2
        },
        {
            header: "Revendedor",
            content: (x: IConferencesAgent) => x.revendedor,
            textAlign: "left",
            width: 5
        },
        {
            header: "Cidade",
            content: (x: IConferencesAgent) => x.cidade,
            textAlign: "left",
            width: 3
        },
        {
            header: "R$ Vendido",
            content: (x: IConferencesAgent) => numberFormat.Currency((x.valorVendido)),
            textAlign: "center",
            width: 2
        },
        {
            header: "R$ Receber",
            content: (x: IConferencesAgent) => numberFormat.Currency((x.valorReceber)),
            textAlign: "center",
            width: 2
        },
        {
            header: "R$ Recebido",
            content: (x: IConferencesAgent) => numberFormat.Currency((x.valorRecebido)),
            textAlign: "center",
            width: 2
        },
    ];

    return (
        <>
            <AliancaMenu />
            <Container className="app-margin">
                {loading ? <Segment><CustomLoader /></Segment> :
                    <Grid columns="equal">
                        <Grid.Row>
                            <Grid.Column>
                                <Header size="huge" content={`Conferencias detalhada por representante`} icon="pie graph" />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Form>
                                    <Form.Group widths="equal">
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="month"
                                                placeholder="Selecione o mês"
                                                label="Mês"
                                                options={optionsMonth}
                                                value={state.month}
                                                onChange={onDropdownChange}
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="year"
                                                placeholder="Selecione o ano"
                                                label="Ano"
                                                options={optionsYear}
                                                value={state.year}
                                                onChange={onDropdownChange}
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Group widths="equal">
                                        <Form.Field>
                                            <Form.Dropdown
                                                fluid
                                                selection
                                                search
                                                scrolling
                                                name="agentId"
                                                noResultsMessage="Nenhum registro encontrado."
                                                placeholder="Selecione"
                                                label="Representante"
                                                onChange={onDropdownChange}
                                                options={agents.map(agent => { return { key: agent.id, value: agent.id, text: agent.nome } })}
                                                value={state.agentId}
                                                clearable
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Button
                                    fluid
                                    icon="search"
                                    color="pink"
                                    content="Pesquisar"
                                    onClick={load}
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Column>
                            <Grid.Row>
                                <TableApp
                                    render={tableRender}
                                    list={list}
                                    loading={loading}
                                />
                            </Grid.Row>
                        </Grid.Column>
                    </Grid>
                }
            </Container>
            <Footer />
        </>
    );
};

export default ConferencesByAgent;
